import { without, findIndex, propEq, reject } from "ramda";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useFavoriteStore = create(
  persist(
    (set, get) => ({
      favorites: [],
      checkIsFavorite: imdbId => {
        const { favorites } = get();
        if (imdbId) {
          return findIndex(propEq(imdbId, "imdbId"))(favorites) !== -1;
        }

        return false;
      },
      addToFavorites: favoriteMovie => {
        const { favorites, checkIsFavorite } = get();
        if (!checkIsFavorite(favoriteMovie.imdbId)) {
          set({
            favorites: [favoriteMovie, ...without([favoriteMovie], favorites)],
          });
        }
      },
      removeFromFavorites: imdbId => {
        const { favorites } = get();
        set({
          favorites: reject(propEq(imdbId, "imdbId"), favorites),
        });
      },
    }),
    {
      name: "favorites-store",
    }
  )
);
